import * as React from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Box } from "@mui/material";
import { useAppStore } from "../../appStore";
import dayjs from "dayjs";

export default function CustomizedDatePickerForHistory() {
  const { setSelectedFromDateHistory, setSelectedToDateHistory } =
    useAppStore();
  const [fromDate, setFromDate] = React.useState(dayjs());
  const [toDate, setToDate] = React.useState(dayjs());

  const formatDate = (date) => dayjs(date).format("YYYY-MM-DD");

  React.useEffect(() => {
    const today = dayjs().format("YYYY-MM-DD");
    setSelectedFromDateHistory(today);
    setSelectedToDateHistory(today);
  }, [setSelectedFromDateHistory, setSelectedToDateHistory]);

  const handleFromDateChange = (date) => {
    if (!date || !date.isValid()) return;

    setFromDate(date);
    setSelectedFromDateHistory(formatDate(date));

    if (date.isAfter(toDate, "day")) {
      setToDate(date);
      setSelectedToDateHistory(formatDate(date));
    }
  };

  const handleToDateChange = (date) => {
    if (!date || !date.isValid()) return;

    setToDate(date);
    setSelectedToDateHistory(formatDate(date));
  };

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: { xs: 1, sm: 1.5 },
        flexWrap: "nowrap",
        width: { xs: "100%", md: "auto" },
        minWidth: 0,
      }}
    >
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Box
          sx={{
            width: { xs: "calc(50% - 4px)", sm: 210 },
            minWidth: 0,
          }}
        >
          <DatePicker
            label="From Date"
            value={fromDate}
            onChange={handleFromDateChange}
            maxDate={toDate}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
                sx: {
                  "& .MuiInputBase-input": {
                    px: { xs: 1, sm: 1.75 },
                  },
                },
              },
            }}
          />
        </Box>
        <Box
          sx={{
            width: { xs: "calc(50% - 4px)", sm: 210 },
            minWidth: 0,
          }}
        >
          <DatePicker
            label="To Date"
            value={toDate}
            onChange={handleToDateChange}
            minDate={fromDate}
            format="DD/MM/YYYY"
            slotProps={{
              textField: {
                size: "small",
                fullWidth: true,
                sx: {
                  "& .MuiInputBase-input": {
                    px: { xs: 1, sm: 1.75 },
                  },
                },
              },
            }}
          />
        </Box>
      </LocalizationProvider>
    </Box>
  );
}
